import { get } from 'vio-libs';
export function getLockers(organization, consumerAPI = false) {
    if (!consumerAPI) {
        return get(`lockers-v2?organization=${organization}`);
    }
    return get(`v1/${organization}/lockers?expand=organization,edge_location`, undefined, true);
}
export function getSiteLockers(organization, locationSlug, consumerAPI = false) {
    if (!consumerAPI) {
        return get(`lockers-v2?organization=${organization}&location=${locationSlug}`);
    }
    return get(`v1/${organization}/lockers?edge_location=${locationSlug}&expand=organization,edge_location`, undefined, true);
}
